import { Tabs } from 'components-antd';
import styles from './styles.module.scss';

export const WorkshopPageTabs = (props) => {
  const { defaultActiveKey, items, onChange, activeKey } = props;

  return (
    <Tabs
      centered
      className={styles.workshopPageTabs}
      defaultActiveKey={defaultActiveKey}
      items={items}
      onChange={onChange}
      {...(activeKey && { activeKey })}
    />
  );
};
